import { render } from "./cvView-21.vue?vue&type=template&id=04148f7f&scoped=true"
import script from "./cvView-21.vue?vue&type=script&lang=js"
export * from "./cvView-21.vue?vue&type=script&lang=js"

import "./cvView-21.vue?vue&type=style&index=0&id=04148f7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04148f7f"]])

export default __exports__